<ion-footer class="legal-footer" role="contentinfo" [class.is-collapsed]="collapsed">
  <ion-toolbar>
    <div class="legal-footer__header">
      <ion-button
        fill="clear"
        size="small"
        (click)="toggleCollapsed()"
        [attr.aria-expanded]="!collapsed"
        aria-controls="legal-footer-panel"
      >
        Legal
      </ion-button>
      <div class="legal-footer__header-actions">
        <ion-button
          class="legal-footer__coffee-button"
          fill="solid"
          size="small"
          color="warning"
          href="https://buymeacoffee.com/apullu"
          target="_blank"
          rel="noopener noreferrer"
        >
          <ion-icon slot="start" name="cafe-outline"></ion-icon>
          Buy Me a Coffee
        </ion-button>
        <ion-button
          class="legal-footer__group-button"
          fill="solid"
          size="small"
          color="primary"
          href="https://groups.google.com/u/1/g/noisy-user-app-testers/about"
          target="_blank"
          rel="noopener noreferrer"
        >
          Join Google Group
        </ion-button>
        <ion-button fill="clear" size="small" (click)="openCookiePreferences()">
          Cookie Preferences
        </ion-button>
      </div>
    </div>
    <div class="legal-footer__panel" id="legal-footer-panel">
      <div class="legal-footer__links">
        <ion-button fill="clear" size="small" routerLink="/privacy">Privacy</ion-button>
        <ion-button fill="clear" size="small" routerLink="/terms">Terms</ion-button>
        <ion-button fill="clear" size="small" routerLink="/cookies">Cookies</ion-button>
        <ion-button fill="clear" size="small" routerLink="/dmca">DMCA</ion-button>
        <ion-button fill="clear" size="small" routerLink="/dmca" fragment="sound-credits">Sound Credits</ion-button>
        <ion-button fill="clear" size="small" routerLink="/accessibility">Accessibility</ion-button>
        <ion-button fill="clear" size="small" routerLink="/security">Security</ion-button>
        <ion-button fill="clear" size="small" routerLink="/contact">Contact</ion-button>
        <ion-button
          fill="clear"
          size="small"
          (click)="openCookiePreferences()"
          aria-label="Open cookie preferences"
        >
          Cookie Preferences
        </ion-button>
        <ion-button
          *ngIf="authenticated$ | async"
          fill="clear"
          size="small"
          color="danger"
          [disabled]="deleteAccountLoading"
          (click)="openDeleteAccountConfirm()"
        >
          Delete Account
        </ion-button>
      </div>
      <p *ngIf="deleteAccountError" class="legal-footer__status legal-footer__status--error" role="alert">
        {{ deleteAccountError }}
      </p>
      <div class="legal-footer__operator">
        <div>
          <strong>Operator:</strong>
          <span>{{ config.companyName || 'Operator information not configured' }}</span>
        </div>
        <div>
          <strong>Address:</strong>
          <span>{{ config.businessAddress || 'Operator information not configured' }}</span>
        </div>
        <div>
          <strong>Support:</strong>
          <span>{{ config.supportEmail || 'Operator information not configured' }}</span>
          <span *ngIf="config.supportPhone"> | {{ config.supportPhone }}</span>
        </div>
      </div>
    </div>
  </ion-toolbar>
</ion-footer>

<ion-alert
  [isOpen]="deleteAccountConfirmOpen"
  header="Delete account?"
  message="This will anonymize your account and sign you out."
  [buttons]="deleteAccountButtons"
  (didDismiss)="cancelDeleteAccount()"
></ion-alert>
